import axios from "axios";
import { message, Modal } from "ant-design-vue";
import store from "@/store";
import router from "@/router";
const baseURL = process.env.VUE_APP_REQUEST_BASE_URL;
const request = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});
//  请求前
request.interceptors.request.use(
  (config) => {
    if (!config.silent && !config.hideLoading) {
      store.commit("setLoadingState", true);
    }
    config.headers["client-type"] = "web";
    //  token
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);
request.interceptors.response.use(
  (res) => {
    if (!res.config?.silent && !res.config?.hideLoading) {
      setTimeout(() => {
        store.commit("setLoadingState", false);
      }, 300);
    }
    if (![200, 201].includes(res.status)) {
      if (!res.config?.silent) {
        Modal.error({
          title: "操作错误",
          content: res.response?.data?.message || "请求失败",
        });
      }
      return Promise.reject(res);
    }
    return res.data;
  },
  (err) => {
    const config = err.config || {};
    if (!config.silent && !config.hideLoading) {
      store.commit("setLoadingState", false);
    }

    if ([403, 401].includes(err.response?.status)) {
      if (!config.silent) {
        message.error("请先登录");
        router.push("/user/login");
      }
      return Promise.reject(err);
    }
    if (!config.silent) {
      Modal.error({
        title: "操作错误",
        content: "服务器错误 ~ " + (err.response?.data?.message || err.message),
      });
    }
    return Promise.reject(err);
  },
);

export default request;
